import { Injectable } from "@angular/core";
import { ISectionPresenter } from '../../../models/section-presenter';
import { FeatureToggleService } from '../../../../services/feature-toggle/feature-toggle.service';
import { DeviceSettingsFeatureToggle } from "src/app/enums/feature-toggle.enum";
import { ActiveProtectionSystemService } from "src/app/services/smart-assist/active-protection-system/active-protection-system.service";

@Injectable({
	providedIn: 'root'
})

export class ActiveProtectionSystemSection implements ISectionPresenter {
	constructor(
		private featureToggleService: FeatureToggleService,
		private activeProtectionSystemService: ActiveProtectionSystemService
	) {}

	public async isVisible(): Promise<boolean> {
		const isFeatureToggleEnabled = this.featureToggleService.isDeviceSettingsFeatureAvailable(
			DeviceSettingsFeatureToggle.SmartAssistActiveProtectionSystem
		);
		const isAPSAvailable = await this.activeProtectionSystemService.isAvailable();

		return isFeatureToggleEnabled && isAPSAvailable;
	}
}
